import React, { useContext, useEffect } from 'react';
import { FirebaseContext } from '../firebase/context';
import { IconButton, Button, Paper } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';


const signInWithGoogle = (firebase, history, params) => {
    //TODO: if you are already authenticated, redirect to exercise 1 
    const provider = new firebase.auth.GoogleAuthProvider();

    // if we do the popup, we can easily tell if they are isNewUser
    // with redirect, we don't have access to this info to create a new user profile
    firebase.auth().signInWithPopup(provider)
        .then(res => {
            if (res.additionalUserInfo.isNewUser) {
                const db = firebase.firestore();
                db.collection('users').doc(res.user.uid).set({
                    uid: res.user.uid,
                    first: res.additionalUserInfo.profile.given_name || "",
                    last: res.additionalUserInfo.profile.family_name || "",
                    hasSubmitted: false,
                    isAdmin: false,
                    email: res.additionalUserInfo.profile.email
                }).then(res => {

                    // this is needed for popup, but not redirect. Will remove if we keep redirect.
                    history.push(`/${params.role || 'se'}/exercise/0`)
                })
            } else {

                // this is needed for popup, but not redirect. Will remove if we keep redirect.
                history.push(`/${params.role || 'se'}/exercise/0`)
            }
        })
        .catch(err => alert(err))
}

const useStyles = makeStyles((theme) => ({
    paper: {
        minHeight: '500px',
        margin: '0 auto',
        width: '450px',
        transform: 'translatey(50%)',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    root: {
        padding: 0
    }
}));

const SignInForm = () => {
    const history = useHistory();
    const fb = useContext(FirebaseContext);
    const classes = useStyles();
    const params = useParams()

    return (
        <Button className={classes.root} onClick={() => signInWithGoogle(fb, history, params)}><img alt="Sign in with Google" style={{ height: '60px' }} src="../assets/images/btn_google_signin_dark_pressed_web@2x.png" /></Button>
    )
}

const SignIn = () => {
    const fb = useContext(FirebaseContext);
    const history = useHistory();
    const classes = useStyles();

    // this is only needed if we redirect, not popup
    const redirectOnSignIn = () => {
        fb.auth().onAuthStateChanged(user => {
            if (user) {
                history.push('/exercise/0')
            }
        })
    }

    useEffect(() => {
        //when SignIn page loads, listen for the auth redirect and send to the exercise if authenticated
        // redirectOnSignIn()
    }, [])


    return (
        <div>
            <Paper className={classes.paper}>
                <div>
                    <h1>Welcome to the Quantum Metric SE Exercise!</h1>
                    <h3>Login with a Google account to get started.</h3>
                </div>
                <div>
                    <SignInForm />
                </div>
                <p>You can link an existing email address with Google if you follow <a target="_blank" href="https://support.google.com/accounts/answer/176347">these instructions</a></p>
            </Paper>
        </div>
    );
}

export default SignIn